import set from 'lodash/set';
import stringUtils from './string';
import isObject from 'lodash/isObject';
import { CustomObject } from '../types';

export const parseValidation = (props: CustomObject) => {
	if (!isObject(props)) {
		return {};
	}

	const normalizedCaseProp = Object.keys(props).reduce((memo, key) => {
		let normalizedKey = key
			.split('.')
			.map((key) => {
				if (!key) return '';

				return stringUtils.toLowerCaseFirstLetter(key);
			})
			.join('.');

		/*
				normalize array notation
				EXAMPLE, from: 'user[1].address[0]' => 'user.1.address.0'
			 */
		if (normalizedKey.indexOf('[') !== 1 && normalizedKey.indexOf(']') !== -1) {
			normalizedKey = normalizedKey.replace(/\[/g, '.').replace(/]/g, '');
		}

		return {
			...memo,
			[normalizedKey]: props[key],
		};
	}, {});

	const plainProps = {};

	Object.keys(normalizedCaseProp).forEach((key) => {
		set(plainProps, key, normalizedCaseProp[key]);
	});

	/*
		perform json operations to fill undefined array elements with null
		EXAMPLE
		from: {
			foo: 'bar',
			userIds: [undefined, 1, 2]
		}
		to: {
			foo: 'bar',
			userIds: [null, 1, 2]
		}
	 */
	return JSON.parse(JSON.stringify(plainProps)) as CustomObject;
};
